import Image from "next/image";

function EssentialLeftSection() {
  return (
    <div className="w-[50%] relative">
      <div className="relative w-fit">
        <div className="relative w-[400px] h-[468px] md:w-[500px] md:h-[578px] lg:w-[600px] lg:h-[703px] xl:w-[661px] xl:h-[764px] -left-[9rem] rotate-[4deg] lg:rotate-0 md:-left-[8rem] lg:-left-[6rem] xl:-left-[0.5rem] 2xl:left-0 top-[2rem] lg:top-[6rem] aspect[661/764] z-10">
          <Image
            src="/assets/pet-tag/essential-card.png"
            fill
            alt="Card"
            priority
          />
        </div>
        <div className="absolute w-[150px] h-[151px] md:w-[189px] md:h-[191px] rotate-[350deg] top-[3rem] left-[7rem] md:top-[5.3rem] md:left-[11rem] lg:top-[12.3rem] lg:left-[1rem] xl:left-[3.8rem]">
          <Image src="/assets/pet-tag/essential-paw-left.svg" fill alt="Paw" />
        </div>
        <div className="absolute scale-x-[-1] lg:scale-x-[1] top-[15rem] right-[17rem] md:top-[21rem] md:right-[20rem] w-[200px] h-[225px] lg:w-[200px] lg:h-[225px] xl:w-[353px] xl:h-[398px] lg:top-[25rem] xl:top-[20rem] lg:-right-[2.5rem] xl:-right-[7.5rem]">
          <Image
            src="/assets/pet-tag/essential-paw-center.svg"
            fill
            alt="Paw"
          />
        </div>
        <div className="absolute w-[63px] h-[63px] top-[1.2rem] -left-[1rem] md:top-[1.2rem] md:left-[2rem] scale-x-[-1] lg:hidden block">
          <Image
            src="/assets/pet-tag/essential-paw-right-top.svg"
            fill
            alt="Paw"
          />
        </div>
      </div>
    </div>
  );
}

export default EssentialLeftSection;
